import {PortsItemChunk} from "../../chunks/types/PortsItemChunk";
import {getSpreadOpFromPortDeclChunk} from "./getSpreadOpFromPortDeclChunk";

export function getSpreadOpFromPortsItemChunk(
  portsItemChunk: PortsItemChunk
): string | null {
  const {
    captures: {
      1: portDeclChunk
    }
  } = portsItemChunk;
  return getSpreadOpFromPortDeclChunk(portDeclChunk);
}
